import styled, { Theme, ThemeProps } from '@themes/theme'
import {
  CommonLimitStyle,
  CommonTxtBoxStyle,
  NavBottomPadding, PCModalMaxWidth,
  SafeAreaConstantPadding,
  SafeAreaEnvPadding,
  TxtLimit,
  TxtLimit2,
  UploadImgPreviewCommonStyle,
} from '@styles/base.style'
import { css, keyframes } from '@emotion/core'
import { favoritePulseAni, favoriteTxtAni } from '@styles/match.style'
import { ButtonStyles } from '@styles/button.style'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'

export const HomeWrap = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  &.pc-home-wrap {
    overflow: auto;
  }
`
export const HomeBanner = styled.div`
  width: 100%;
  min-height: 365px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: auto;
    &.txt-img {
      transform: translateY(-42vw);
    }
  }
  &.m-home-banner {
    min-height: 109vw;
    margin-top: -40px;
    .login-btn {
      position: absolute;
      top: 0;
      right: 12px;
    }
  }
`

export const SkeletonDarkGradientAni = keyframes`
  0% {
    background-position: 150% 0;
  }
  100% {
    background-position: -150% 0;
  }
`

export const DarkSkeletonStyle = css`
  position: relative;
  display: inherit;
  height: inherit;
  overflow: hidden;
  background: #212732 !important;
  border-radius: 50px;
  &::before {
    content:'';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to left, rgba(44, 51, 64, 0), rgba(44, 51, 64, 1), rgba(44, 51, 64, 0));
    background-size: 300%;
    background-repeat: no-repeat;
    animation: ${SkeletonDarkGradientAni} 1.8s infinite ease;
  }
`

export const HomeContentsWrap = styled.article`
  display: flex;
  flex-flow: column;
  height: 100%;
  margin-bottom: 36px;
  z-index: 1;
  &.banner {
    margin-bottom: 9px;
    // 로딩
    &.skeleton {
      padding: 0 14px;
      .banner-btn.dark-skeleton {
        width: 100%;
        min-height: 77px;
        border-radius: 4px;
      }
      // PC버전 배너
      .right-navigation {
        .banner-btn.dark-skeleton {
          min-height: 110px;
        }
      }
    }
  }
  &.today-pick-contents, &.user-pick-contents {
    align-items: flex-end;
    margin-bottom: 30px;
  }
  .home-tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 21px;
    .tit {
      display: flex;
      align-items: center;
      font-size: ${props => props.theme.font.title};
      .sub-tit {
        margin-left: 9px;
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.btn};
      }
    }
    .arrow {
      width: 12px;
      transform: rotate(-90deg);
    }
  }
  .pick-bg-wrap {
    position: relative;
    &:not(.pc) {
      margin-top: -60px;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .pick-profile {
    width: 30px;
    height: 30px;
    margin-right: 9px;
    border-radius: 50%;
    overflow: hidden;
    background: ${props => props.theme.color.themeTxt};
    img {
      width: inherit;
      height: auto;
      image-rendering: -webkit-optimize-contrast;
    }
    &.big {
      width: 60px;
      height: 60px;
      transform: translateY(-14px);
      margin-right: 18px;
    }
  }
  // 프리미엄 분석가
  .notice {
    position: relative;
    display: flex;
    align-items: start;
    width: 100%;
    padding: 9px 14px 5px 27px;
    .bg {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 100%;
      height: 100%;
      opacity: .1;
      background: ${props => props.theme.color.btn};
    }
    .txt {
      line-height: 160%;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      letter-spacing: -0.4px;
      border-radius: 0;
      text-align: left;
      width: auto;
      ${TxtLimit};
      &.over-txt {
        margin-right: auto;
      }
    }
    svg {
      width: 18px;
      min-width: 18px;
      height: auto;
      margin-right: 12px;
      margin-top: 2px;
    }
    // 프리미엄 분석가 페이지 내 공지
    &.page-notice {
      padding: 10px 36px;
      margin-bottom: 18px;
      .txt {
        font-size: ${props => props.theme.font.medium};
      }
      svg {
        width: 14px;
        min-width: 14px;
      }
      &.open {
        height: auto;
        .txt {
          overflow: auto;
          white-space: normal;
          height: auto;
        }
      }
    }
    &.open {
      height: auto;
      .txt {
        overflow: auto;
        white-space: normal;
        height: auto;
      }
    }
  }
  .go-favorite-tab-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    height: 45px;
    margin: 18px 18px 0 0;
    padding: 0 18px;
    background: ${props => props.theme.color.mainBg};
    &::before {
      content:'';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: inherit;
      border: 1px solid ${props => props.theme.color.btn};
      opacity: .5;
      border-radius: 50px;
    }
    .left-item {
      margin-right: 9px;
      line-height: 18px;
      font-size: ${props=> props.theme.font.large};
      .favorite-svg {
        width: auto;
        height: 15px;
        margin-right: 4px;
        color: ${props => props.theme.color.yellow};
        transform: translateY(2px);
        path{
          fill: transparent;
        }
        .fill {
          fill: ${props => props.theme.color.yellow};
        }
      }
    }
    .arrow-svg {
      width: auto;
      height: 6px;
      color: ${props => props.theme.color.disableTxt2};
      transform: rotate(-90deg);
    }
    &.pc {
      margin-top: -39px;
    }
    &.disabled {
      .left-item {
        color: ${props => props.theme.color.disableTxt2};
      }
      svg .fill {
        fill: ${props => props.theme.color.subColor};
      }
    }
  }

  &.skeleton {
    .swiper-slide > div {
      background: ${props => props.theme.color.mainColor};
    }
    .dark-skeleton, .gray-skeleton {
      position: relative;
      display: inline-block;
      height: 14px;
      overflow: hidden;
      background: #212732;
      border-radius: 50px;
      &::before {
        content:'';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to left, rgba(44, 51, 64, 0), rgba(44, 51, 64, 1), rgba(44, 51, 64, 0));
        background-size: 300%;
        background-repeat: no-repeat;
        animation: ${SkeletonDarkGradientAni} 1.8s infinite ease;
      }
    }
    .gray-skeleton {
      background: #2C3340;
      &::before {
        background-image: linear-gradient(to left, rgba(49, 57, 71, 0), rgba(49, 57, 71, 1), rgba(49, 57, 71, 0));
      }
    }
    .home-banner {
      padding: 0 18px;
    }
    .home-tit .tit {
      width: 100%;
      .txt {
        width: 100px;
        height: 18px;
      }
    }
    .notice .txt {
      width: 150px;
    }
    .sports-icon {
      width: 18px;
      height: 18px;
      margin-right: 6px;
      vertical-align: middle;
    }
    .tournament {
      width: 70px;
      vertical-align: middle;
    }
    .match-info {
      .date {
        width: 80px;
      }
      .select-info {
        width: 30px;
      }
      .team {
        .emblem {
          width: 18px;
        }
        .team-name {
          width: 85px;
        }
        &.home-team {
          .team-name {
            width: 105px;
          }
        }
      }
    }
    .sub-info.skeleton {
      justify-content: flex-start;
      .profile {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      .comment-num {
        width: 30px;
      }
    }
  }
  // 프리미엄분석가 상세 페이지
  &.today-pick-detail-wrap {
    .title-wrap {
      &.pc {
        transform: translateY(40px);
        justify-content: flex-start;
      }
    }
    .pick-bg-wrap {
      width: 100%;
      aspect-ratio: 520 / 427;
      .pick-page-bg {
        width: 100%;
      }
    }
  }
`
export const TodayPickProfile = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: -18%;
  padding: 21px 30px;
  border-radius: 30px 30px 0 0;
  background: ${props => props.theme.color.mainBg};
  .pick-profile {
    min-width: 60px;
    &.is-profile-custom {
      background: none;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .profile-info {
    .nick-name-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      .name {
        width: auto;
        margin-bottom: 2px;
        line-height: 2.7rem;
        font-size: ${props => props.theme.font.largeNum};
      }
      .mark {
        position: static;
          transform: translateY(-1px);
      }
    }
    .introduction {
      line-height: 1.8rem;
      color: ${props => props.theme.color.disableTxt2};
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
    }
    .community-score {
      .line {
        width: 18px;
        height: 2px;
        margin: 12px 0 14px;
        background: ${props => props.theme.color.contentsBg};
      }
      .txt {
        color: ${props => props.theme.color.disableTxt2};
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.bold};
        &:first-of-type {
          margin-right: 19px;
        }
      }
    }
  }
`
export const StateListStyle = (props:ThemeProps) => css`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  &--item {
    font-weight: ${props.theme.fontW.medium};
    color: ${props.theme.color.modalSubTxt};
    .circle {
      display: inline-block;
      width: 8px;
      height: 8px;
      margin-right: 4px;
      border-radius: 50%;
      &.success {
        background: ${props.theme.color.secondaryBg};
      }
      &.fail {
        background: ${props.theme.color.gray};
      }
      &.cancel {
        background: ${props.theme.color.purple};
      }
    }
  }
`
export const PickList = styled.div`
  padding: 0 14px ${NavBottomPadding};
  text-align: left;
  .am-list {
    max-width: 100%; /* PC버전에서 팀명 길어질 시 좌우 넘어가는 현상 해결 */
    min-height: 100%; /* footer에 empty 이미지가 들어갈때 100%여야 하단 빈공간이 안생김*/
  }
  .score-wrapper {
    margin-left: 8px;
  }
  &.pc-pick-list {
    height: 100%;
    padding: 0;
    .am-list-view-scrollview {
      height: 100%;
      .am-list-body {
        padding: 0 18px;
      }
      .page-item {
        margin: 12px 18px 0;
        &:first-child {
          margin-top: 18px;
        }
      }
    }
  }
  &.user-pick-detail-list {
    padding: 12px 18px 6px;
    background: ${props => props.theme.color.mainColor};
    .state-list {
      ${StateListStyle};
      position: absolute;
      left: 50%;
      transform: translateX(-40%);
      &--item {
        color: ${props => props.theme.color.disableTxt};
      }
    }
  }
  // 유저 프로필 팝업
  &.user-pick-detail-popup-list {
    height: 100%;
    padding: 0;
    //border: 1px solid green;
    .am-list {
      max-width: 100%;
      height: 100%;
      background: ${props => props.theme.color.mainBg};
      //border: 1px solid red;
      .am-list-body {
        //padding: 9px 12px;
        background: ${props => props.theme.color.mainColor};
        //border: 1px solid blue;
      }
    }
  }
  &.userPickList {
    height: 100%;
    .am-list-view-scrollview {
      height: 100%;
    }
    &.pc-pick-list {
      .am-list-view-scrollview {
        padding-top: 18px;
      }
    }
  }
  &.userPickFilterList {
    padding: 0;
    .am-list-view-scrollview {
      height: calc(100vh - 108px);
      overflow: auto;
      padding: 0 14px ${NavBottomPadding};
    }
    &.pc-pick-list {
      .am-list-view-scrollview {
        height: calc(100vh - 194px);
        padding: 0;
      }
    }
  }
`
const PickBtnCommonStyle = (props:ThemeProps) => css`
  display: flex;
  align-items: center;
  flex: 1;
  width: auto;
  height: 36px;
  padding: 0 24px;
  color: ${props.theme.color.btn};
  border-radius: 0;
`
export const PickItem = styled.div`

  // 프리미엄 분석가
  &.today-pick {
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 211px;
    margin-top: 12px;
    padding: 21px 0 12px;
    background: ${props => props.theme.color.subColor};
    border-radius: 18px;
    box-shadow: 5px 10px 20px rgba(22, 26, 35, .6);
    .pick-info {
      width: 100%;
      height: auto;
      border-radius: 0;
      .select-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 24px 9px;
        .market-info {
          display: flex;
          align-items: center;
          .rate {
            margin-right: 10px;
            font-size: ${props => props.theme.font.title};
            color: ${props => props.theme.color.yellow};
          }
          .market-type {
            display: inline-block;
            width: auto;
            height: 18px;
            line-height: 18px;
            padding: 0 5px;
            border-radius: 4px;
            color: ${props => props.theme.color.mainBg};
            background: ${props => props.theme.color.disableTxt2};
          }
        }
        .hit-state {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: transparent;
          &.success {
            background: ${props => props.theme.color.secondaryBg};
          }
          &.fail {
            background: ${props => props.theme.color.disableTxt};
          }
          &.cancel {
            background: ${props => props.theme.color.purple};
          }
        }
      }
      .match-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        height: 42px;
        margin: 0 9px;
        padding: 0 12px;
        background: ${props => props.theme.color.mainColor};
        border-radius: 9px;
        text-align: left;
        .team-info {
          display: flex;
          align-items: center;
          width: calc((100% - 36px) / 2);
          max-width: calc((100% - 36px) / 2);
          .team-name {
            ${TxtLimit};
            height: 16px;
            line-height: 1.8rem;
          }
          .team-emblem {
            width: auto;
            height: 16px;
          }
          &.home {
            .team-name {
              text-align: left;
            }
            .team-emblem {
              margin-right: 4px;
            }
          }
          &.away {
            justify-content: flex-end;
            .team-name {
              text-align: right;
            }
            .team-emblem {
              margin-left: 4px;
            }
          }
        }
        .match-time {
          display: flex;
          flex-flow: column;
          .date {
            font-size: ${props => props.theme.font.small};
            color: ${props => props.theme.color.disableTxt2};
          }
          .time {
            font-size: ${props => props.theme.font.small};
          }
        }
      }
      .pick-tit {
        ${TxtLimit2};
        width: calc(100% - 48px);
        height: 4.2rem;
        max-height: 4.2rem;
        line-height: 2.1rem;
        text-align: left;
        margin: 14px auto 0;
        font-weight: ${props => props.theme.fontW.medium};
        .comments {
          display: inline-block;
          //transform: translateY(-1px);
          margin-left: 4px;
          color: ${props => props.theme.color.btn};
        }
      }
    }
    .pick-option {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: auto;
      padding-top: 6px;
      .line {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 18px);
        height: 1px;
        background: ${props => props.theme.color.mainBg};
        box-shadow: 0 1px 1px rgba(64, 80, 96, .3);
      }
      // 베팅 추가 버튼
      .cart-btn {
        ${PickBtnCommonStyle};
        .plus-ico {
          position: relative;
          width: 12px;
          height: 12px;
          margin-right: 10px;
          transform: scale(1.2) translateY(-1px);
          .line {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 1px;
            background: ${props => props.theme.color.btn};
            &.line-2 {
              width: 1px;
              height: 100%;
            }
          }
        }
      }
      // 좋아요 버튼
      .like-btn {
        ${PickBtnCommonStyle};
        flex: initial;
        justify-content: flex-end;
        svg {
          width: 30px;
          height: 30px;
          margin-right: 4px;
          fill: ${props => props.theme.color.btn};
        }
        .like-num {
          margin-left: 4px;
          color: ${props => props.theme.color.btn};
        }
        &.active {
          svg .fill {
            fill: ${props => props.theme.color.underover};
          }
        }
      }
      //&.home-pick-option {
      //  justify-content: flex-end;
      //  .like-btn {
      //    flex: initial;
      //  }
      //}
    }
    // 프리미엄 분석가 페이지 픽 리스트
    &.page-item {
      .match-info {
        margin: 0 18px;
      }
    }
    &.pc-pick-item {
      margin-bottom: 52px;
      // hover 효과
      // 베팅 추가 버튼
      // .cart-btn {
      //   &:hover {
        //     color: ${props => props.theme.color.disableTxt2};
      //     .line {
        //       background: ${props => props.theme.color.disableTxt2};
      //     }
      //   }
      // }
      // 좋아요 버튼
      .like-btn {
        &:not(.active):hover {
          svg {
            fill: ${props => props.theme.color.disableTxt2};
          }
        }
        &:hover {
          &, .like-num {
            color: ${props => props.theme.color.disableTxt2};
          }
        }
      }
    }
  }
`
const SelectBoxStyle = (props: ThemeProps) => css`
  position: relative;
  width: 100%;
  height: auto;
  line-height: 18px;
  padding: 6px 0;
  font-size: ${props.theme.font.large};
  font-weight: ${props.theme.fontW.medium};
  color: ${props.theme.color.disableTxt2};
  text-align: center;
  border-radius: 12px;
  background: ${props.theme.color.modalBg};
  .outcome {
    line-height: 24px;
    .selection {
      ${TxtLimit};
      display: inline-block;
      max-width: calc(100% - 80px);
      font-size: ${props.theme.font.title};
      font-weight: ${props.theme.fontW.medium};
      color: ${props.theme.color.themeTxt};
      vertical-align: middle;
    }
    .outcome-rate {
      margin-left: 4px;
      font-size: ${props.theme.font.title};
      font-weight: ${props.theme.fontW.medium};
      color: ${props.theme.color.yellow};
      vertical-align: middle;
    }
  }
  .rate {
    font-size: ${props.theme.font.large};
    color: inherit;
  }
  .circle {
    position: absolute;
    top: 8px;
    right: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    &.success {
      background: ${props.theme.color.secondaryBg};
    }
    &.fail {
      background: ${props.theme.color.gray};
    }
    &.cancel {
      background: ${props.theme.color.purple};
    }
    &.ongoing {
      width: auto;
      height: auto;
      font-size: ${props.theme.font.small};
      color: ${props.theme.color.modalgray};
      transform: translateY(-2px);
    }
  }
`
const CommonTagStyle = (props: ThemeProps) => css`
  display: inline-block;
  width: auto;
  height: 20px;
  line-height: 22px;
  transform: translate(6px, 0);
  padding: 0 4px;
  font-size: 11px;
  font-weight: ${props.theme.fontW.bold};
  border-radius: 4px;
`
export const UserPickWrap = styled.div`
  width: 100%;
  &.page-pick-wrap {
    height: 100%;
  }
  .swiper-slide {
    &.go-page {
      max-width: 75px;
      .btn-ico {
        margin-left: 2px;
        transform: rotate(-90deg);
      }
      .txt-wrap {
        display: inline-block;
      }
    }
  }
  .today-user-pick-btn {
    position: relative;
    padding-right: 12px;
    background: linear-gradient(to bottom, #FEF0C5, #F9E2B2 50%, #E7C69B, #CFAC89);
    .btn-bg {
      width: auto;
      height: 100%;
    }
    .txt-wrap {
      position: relative;
      top: 50%;
      transform: translateY(-45%);
      margin-right: 6px;
      .small {
        height: 14px;
      }
      .big {
        height: 17px;
      }
      .today-txt {
        display: block;
      }
      .user-count {
        color: #E56C01;
        font-size: 17px;
        line-height: 15px;
        font-weight: ${props => props.theme.fontW.bold};
        vertical-align: middle;
      }
      .txt-img {
        &.small {
          transform: translate(1px, -5%);
        }
      }
    }
    .btn-ico {
      position: relative;
      top: 50%;
      transform: rotate(-90deg) translate(5px, -5%);
    }
  }
  &.pc-pick-wrap {
    position: relative;
    .swiper-slide {
      .pick-item {
        margin-bottom: 52px;
      }
    }
    .today-user-pick-btn {
      position: absolute;
      bottom: -5px;
      left: 120px;
      margin: 0;
    }
    .pc-write-btn {
      position: relative;
      z-index: 1;
      margin-top: -39px;
      transform: translateY(3px);
    }
    &.no-pick {
      //.today-user-pick-btn {
      //  left: 18px;
      //}
      //.pc-write-btn {
      //  margin-top: 30px;
      //}
      .swiper-wrapper {
          height: 227px;
      }
    }
  }
  .match-info {
    width: 100%;
    padding: 9px 18px 12px;
    .date {
      display: inline-block;
      line-height: 1.8rem;
      color: ${props => props.theme.color.disableTxt2};
      margin-bottom: 8px;
      vertical-align: middle;
      .today {
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalSubBg2};
      }
    }
    .top-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      vertical-align: middle;
      align-items: center;
      .date {
        margin-bottom: 0;
      }
      .live-tag {
        ${CommonTagStyle};
        color: ${props => props.theme.color.themeTxt};
        background: ${props => props.theme.color.red};
      }
      .end-tag {
        ${CommonTagStyle};
        color: ${props => props.theme.color.darkTxt};
        background: ${props => props.theme.color.disableBg};
      }
      .cancel-tag {
        ${CommonTagStyle};
        color: ${props => props.theme.color.disableTxt2};
        background: ${props => props.theme.color.mainBg};
      }
    }
    .select-info {
      position: relative;
      display: inline-block;
      .top-info {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
      }
      .market-info {
        display: flex;
        align-items: center;
        .market-type {
          display: inline-block;
          min-width: 15px;
          width: auto;
          height: 15px;
          margin-right: 5px;
          line-height: 15px;
          padding: 0 3px;
          text-align: center;
          border-radius: 4px;
          font-weight: ${props => props.theme.fontW.bold};
          font-size: ${props => props.theme.font.small};
          color: ${props => props.theme.color.mainBg};
          background: ${props => props.theme.color.disableTxt2};
          transform: translate(0, -3%);
        }
        .rate {
          font-size: ${props => props.theme.font.large};
          color: ${props => props.theme.color.yellow};
        }
      }
      .hit-state {
        position: absolute;
        top: -3px;
        right: -10px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 2px solid ${props => props.theme.color.subColor2};
        background: transparent;
        //transform: scale(1.2);
        &.success {
          background: ${props => props.theme.color.secondaryBg};
        }
        &.fail {
          background: ${props => props.theme.color.disableTxt};
        }
        &.cancel {
          background: ${props => props.theme.color.purple};
        }
      }
    }

    .team {
      ${TxtLimit};
      max-width: 100%;
      line-height: 2rem;
      font-size: ${props => props.theme.font.large};
      &.home-team {
        margin-bottom: 6px;
      }
      .emblem {
        display: inline-block;
        width: auto;
        height: 18px;
        margin-right: 6px;
        text-align: center;
        img {
          width: auto;
          height: inherit;
        }
      }
    }

    .score-wrapper {
      display: flex;
      .team {
        flex: 1;
      }
      .score {
        float: right;
        line-height: 140%;
        font-weight: ${props => props.theme.fontW.bold};
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.themeTxt};
        &.win {
          color: ${props => props.theme.color.red};
        }
      }
    }

    &.row {
      .team-info {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 21px;
        line-height: 2.1rem;
        .team {
          ${TxtLimit};
          max-width: 100%;
          display: inline-block;
          font-weight: 500;
          margin-bottom: 0;
          .emblem {
            margin-right: 4px;
            height: 21px;
            img {
              margin-top: -1px;
            }
          }
        }
        .vs {
          width: auto;
          margin: 0 4px;
          color: ${props => props.theme.color.disableTxt2};
        }
      }
    }
    &.simple-info {
      z-index: 1;
      position: relative;
      max-width: 100vw;
      margin-bottom: -9px;
      padding: 21px 18px 0;
      background: ${props => props.theme.color.mainColor};
      & > img {
        width: auto;
        height: 14px;
        margin-right: 6px;
        //transform: translateY(-15%);
      }
      .date {
        margin-bottom: 0;
        margin-right: 8px;
        color: ${props => props.theme.color.btn};
        font-size: ${props => props.theme.font.large};
        white-space: nowrap;
      }
      .team-info {
        position: relative;
        display: inline-flex;
        width: auto;
        max-width: calc(100% - 128px);
        padding-left: 8px;
        vertical-align: middle;
        &::before {
          content:'';
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 10px;
          background: ${props => props.theme.color.contentsBg};
        }
        .team {
          color: ${props => props.theme.color.btn};
        }
        .vs {
          color: ${props => props.theme.color.btn};
        }
      }
    }
    &.popup {
      padding: 0 18px;
      .date {
        margin-bottom: 4px;
      }
      .team-info {
        .team {
          color: ${props => props.theme.color.modalTxt};
          .emblem {
            height: 18px;
            margin-right: 4px;
          }
        }
      }
    }
    &.pc-info {
      max-width: ${PCModalMaxWidth};
    }
  }
  .pick-item {
    width: 100%;
    height: auto;
    margin-bottom: 6px;
    background: ${props => props.theme.color.subColor2};
    border-radius: 18px;
    box-shadow: 5px 10px 20px rgba(28, 32, 43, .6);
    .tournament-info {
      ${TxtLimit};
      max-width: initial;
      padding: 12px 18px 10px;
      font-size: ${props => props.theme.font.large};
      vertical-align: middle;
      background: ${props => props.theme.color.mainColor};
      border-radius: 18px 18px 0 0;
      img {
        width: auto;
        height: 16px;
        margin-top: -1px;
        margin-right: 5px;
      }
    }
    .sub-info {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 18px 14px;
      .line {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 18px);
        height: 1px;
        background: ${props => props.theme.color.mainColor};
        box-shadow: 0 1px 1px rgba(64, 80, 96, .3);
      }
      .writer {
        display: inline-flex;
        align-items: center;
      }
      .user-profile {
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;
        .profile {
          position: relative;
          width: 24px;
          height: 24px;
          &:nth-of-type(1) {
            order: 2;
          }
          &:nth-of-type(2) {
            order: 1;
          }
          &:nth-of-type(3) {
            order: 0;
          }
          &:not(&:last-of-type) {
            margin-left: -4px;
          }
          &::before {
            content:'';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: 3px solid ${props => props.theme.color.subColor2};
            width: 100%;
            height: 100%;
            border-radius: 50%;
            box-sizing: content-box;
          }
          .profile-img-wrap {
            ${ProfileImgWrapStyle};
            width: 24px;
            height: 24px;
            background: ${props => props.theme.color.themeTxt};
          }
        }
      }
      .num {
        margin-left: 6px;
        color: ${props => props.theme.color.btn};
        &.user-num {
          font-size: ${props => props.theme.font.large};
          color: ${props => props.theme.color.darkTxt};
        }
      }
      &.company-pick {
        padding: 6px 18px 12px;
        .comment-num {
          display: inline-flex;
          align-items: center;
          transform: translateY(1px);
          svg {
            width: 27px;
            transform: translateY(-1px);
          }
        }
        // 프로필 배경 스타일 제거
        &.is-profile-custom {
          .profile-img-wrap {
            background: transparent;
          }
        }
        // UserPickProfileGroup 컴포넌트 내 프로필 배경 스타일 제거
        .is-profile-custom {
          .profile-img-wrap {
            background: transparent;
          }
        }
      }
    }
    &.popup {
      padding: 12px 18px 15px;
      text-align: left;
      background: ${props => props.theme.color.themeTxt};
      box-shadow: none;
      .tournament-info {
        padding: 0;
        background: none;
        border-radius: 0;
        img {
          height: 14px;
        }
        .date {
          color: ${props => props.theme.color.disableTxt2};
        }
      }
      .match-info {
        margin: 4px 0 6px;
        padding: 0;
        .team-info {
          .team {
            color: ${props => props.theme.color.modalTxt};
            img {
              height: 18px;
            }
          }
          .vs {
            font-size: ${props => props.theme.font.large};
          }
        }
      }
      .select-box {
        ${SelectBoxStyle};
      }
    }
    .pick-match-info-page {
      .match-info {
        .top-info {
          padding-right: 10px;
        }
        .score-wrapper {
          .score {
            padding-right: 10px;
          }
        }
      }
    }
  }
  * {
    font-weight: ${props => props.theme.fontW.medium};
  }

  &.user-pick-profile {
    margin-bottom: 6px;
    padding: 12px 0 15px;
    background: ${props => props.theme.color.themeTxt};
    border-radius: 12px;
    cursor: pointer;
  }
  // 마이페이지_나의활동_댓글팝업
  &.commet-list {
    .comment-list-match-info {
      padding: 8px 14px 8px 12px;
      display: flex;
      align-items: center;
      background: ${props => props.theme.color.subColor2};
      border-radius: 10px;
      margin-bottom: 4px;
      width: calc(100vw - 36px);
      .team-info {
        max-width: calc(100% - 140px);
        color: ${props => props.theme.color.disableTxt2};
        margin-right: auto;
      }
      .btn-ico {
        display: inline-block;
        width: auto;
        height: 6px;
        transform: rotate(-90deg);
        color: ${props => props.theme.color.disableBg};
        svg {
          width: auto;
          height: inherit;
        }
      }
      &.pc-info {
        width: 378px;
      }
    }
    .pick-comments-list--item {
      &:first-of-type {
        border-top: none;
      }
    }
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 18px;
    }
  }
`
const HomeCardListCommonStyle = css`
  margin-top: 9px;
  padding: 0 18px;
`
export const HomeBannerList = styled.ul`
  ${HomeCardListCommonStyle};
  .list-item {
    &:not(:last-of-type) {
      margin-bottom: 9px;
    }
    .banner-btn {
      width: 100%;
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
  &.pc-home-banner-list {
    overflow: auto;
    .banner-btn {
      min-height: 110px;
    }
  }
  &.banner-list-page {
    padding: 0 18px ${NavBottomPadding};
  }
`
export const HomeTipList = styled.ul`
  ${HomeCardListCommonStyle};
  .list-item {
    &:not(:last-of-type) {
      margin-bottom: 9px;
    }
    .banner-btn {
      display: flex;
      justify-content: space-between;
      width: 100%;
      border-radius: 6px;
      overflow: hidden;
      background: ${props => props.theme.color.mainColor};
      img {
        width: auto;
        max-width: 100%;
        height: auto;
      }
    }
  }
`
export const HomeFooterImgStyle = css`
  width: 100%;
  height: auto;
  margin-top: 24px;
  image-rendering: -webkit-optimize-contrast;
  &.m-home-footer {
    padding-bottom: ${NavBottomPadding};
  }
`
const userPickFavoriteBtnCommonStyle = css`
  width: 27px;
  height: 27px;
  margin: 0;
  .btn-bg {
    display: none;
  }
  svg {
    width: 18px;
  }
`
// 프리미엄 분석가 찜 버튼
export const PickFavoriteBtn = styled.button`
  ${ButtonStyles};
  z-index: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  margin: 0 14px;
  overflow: visible;
  background: ${props => props.theme.color.TP};
  &#companyPickFavoriteBtn {
    svg {
      width: 20px;
    }
  }
  .btn-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background: ${props => props.theme.color.mainBg};
    overflow: hidden;
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 14px;
    height: auto;
    .fill {
      fill: ${props => props.theme.color.disableBg};
    }
  }
  .favorite-pulse {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    &.pulse-2 {
      width: 6px;
      height: 6px;
    }
  }
  &.active {
    .btn-bg {
      overflow: visible;
    }
    svg {
      .fill{
        fill: ${props => props.theme.color.yellow};
      }
    }
    &.ani {
      .favorite-pulse {
        opacity: 1;
        animation: ${favoritePulseAni} .65s 1 ease-out;
        &.pulse-2 {
          animation-delay: .1s;
        }
      }
      svg {
        animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43,-0.78,0,1.66);
      }
    }
  }
  &.disabled {
    opacity: .3;
    .btn-bg {
      background: ${props => props.theme.color.mainColor};
    }
  }
  // 나도 승부사 찜버튼
  &#userPickFavoriteBtn {
    ${userPickFavoriteBtnCommonStyle};
  }
  // 나도 승부사 경기 분석 찜버튼
  &#userPickDetailFavoriteBtn {
    ${userPickFavoriteBtnCommonStyle};
    position: absolute;
    top: 4px;
    right: 14px;
  }
`
export const UserFilterWrap = styled.div`
  .ant-radio-group {
    display: flex;
    min-height: 108px;
    height: auto;
    padding: 10px 14px 18px;
    overflow-x: auto;
    overflow-y: hidden;
    .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
      opacity: .6;
    }
    .ant-radio-button-wrapper {
      min-width: 88px;
      height: auto;
      padding: 0;
      background: none;
      border: none;
      box-shadow: none;
      text-align: center;
      &::before {
        display: none;
      }
      .tab-item {
        position: relative;
        display: inline-flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        .profile {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 64px;
          height: 64px;
          padding: 1px;
          background: ${props => props.theme.color.disableBg};
          border-radius: 50%;
          .bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 50%;
            background: ${props => props.theme.color.mainBg};
          }
          .profile-img-wrap {
            ${ProfileImgWrapStyle};
            width: 52px;
            height: 52px;
          }
          .mark {

            bottom: -1px;
            left: 2px;
            width: 22px;
            height: 22px;
            img {
              border: 3px solid ${props => props.theme.color.mainBg};
            }
          }
          &.is-profile-custom {
            .profile-img-wrap {
              background: none;
            }
          }
        }
        .name {
          margin-top: 6px;
          line-height: 1.8rem;
          font-weight: ${props => props.theme.fontW.regular};
          letter-spacing: -0.2px;
          text-align: center;
        }
        .count {
          line-height: 14px;
          margin-top: 3px;
          color: ${props => props.theme.color.themeTxt};
        }
      }
      &.ant-radio-button-wrapper-checked {
        .tab-item {
          .profile {
            background: linear-gradient(45deg, #aaff00, #88f73d, #42e8bb);
          }
          .count {
            color: ${props => props.theme.color.underover};
          }
        }
      }
    }
    //&.selected {
    //  .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    //    opacity: .6;
    //  }
    //}
  }
  &.mo-user-filter-wrap {
    .ant-radio-group::-webkit-scrollbar {
      display: none;
    }
    &.popup {
      width: 100vw;
    }
  }
  &.pc-user-filter-wrap {
    &.popup {
      width: 414px;
      .ant-radio-group {
        &::-webkit-scrollbar {
          display: block !important;
        }
      }
    }
  }

`
export const MatchChart = styled.div`
  padding: 14px 18px 27px;
  border-bottom: 1px solid ${props => props.theme.color.mainColor};
  .chart-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    .chart-item-value {
      height: 6px;
      &.win {
        background: ${props => props.theme.color.blue};
      }
      &.draw {
        background: ${props => props.theme.color.disableTxt2};
      }
      &.lose {
        background: ${props => props.theme.color.red};
      }
    }
  }
  .chart-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3px;
  }
  .win {
    color: ${props => props.theme.color.blue};
    font-weight: ${props => props.theme.fontW.medium};
  }
  .draw {
    color: ${props => props.theme.color.disableTxt2};
    font-weight: ${props => props.theme.fontW.medium};
  }
  .lose {
    color: ${props => props.theme.color.red};
    font-weight: ${props => props.theme.fontW.medium};
  }
  // 상세 BET 매치요약
  &.game-info-match-chart {
    width: 100%;
    padding: 0 18px;
    margin: 0 0 24px 0;
    .chart-info{
      margin-top: 0;
      position: relative;
    }
    .chart-bar {
      border-radius: 6px;
      overflow: hidden;
      margin-top: 4px;
      position: relative;
      .chart-item-value {
        &.win {
          background: linear-gradient(136deg, #00D5FF, #369EE2);
        }
        &.lose {
          background: linear-gradient(136deg, #C62C4B, #D84E4E);
        }
      }
    }
  }
`
export const FilterStyle = (theme: Theme) => css`
  .btn-ico {
    svg path {
      &#bg {
        fill: none;
      }
      &#arrow {
        fill: ${theme.color.modalSubBg};
      }
    }
  }
  &.started-market-filter {
    .btn-txt {
      ${TxtLimit};
      display: inline-block;
      max-width: 16vw;
      vertical-align: middle;
    }
    &.pc-filter {
      .btn-txt {
        max-width: 86px;
      }
    }
  }

`
export const FilterWrapStyle = css`
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
  align-items: center;
`
const HitRateLightAni = keyframes`
  0% {
    background-position: right;
  }
  15%, 100% {
    background-position: left;
  }
`
const HitRateAni = keyframes`
  8%, 12% {
    text-shadow: 0 0 4px rgba(211, 153, 90, .9);
  }
  0%, 20%, 100% {
    text-shadow: 0 0 4px rgba(211, 153, 90, .3);
  }
`
const AniDuration = '4s'
const AniTimingFunction = 'cubic-bezier(.07,.09,.6,.9)'
export const HitStateSuccessCount = styled.div`
  position: relative;
  text-align: center;
  .light {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    width: 50px;
    height: 30px;
    font-size: ${props => props.theme.font.title};
    background: linear-gradient(135deg, #ffffff00 48%, #fff 49%, #fff 51%, #ffffff00 52%);
    background-size: 250%;
     -webkit-background-clip: text;
     -webkit-text-fill-color: transparent;
    animation: ${HitRateLightAni} ${AniDuration} infinite ${AniTimingFunction};
    &.big {
      background: linear-gradient(135deg, #ffffff00 36%, #fff 37%, #fff 44%, #ffffff00 45%);
      background-size: 250%;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .recent-hit-rate {
    margin: 6px 0 1px;
    font-weight: ${props => props.theme.fontW.bold};
    font-size: ${props => props.theme.font.title};
    color: ${props => props.theme.color.darkTxt};
    &.color {
      background: linear-gradient(to right, #A7EEE9, #559DD5);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    &.effect {
      position: relative;
      background: linear-gradient(to right, #E7E1CF, #D5AA85);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: ${HitRateAni} ${AniDuration} infinite ${AniTimingFunction};
    }
  }
  .hit-state-count {
    color: ${props => props.theme.color.btn};
  }
`
export const UserDetailItem = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 21px 18px 4px 14px;
  background: ${props => props.theme.color.mainColor};
  .profile-wrap {
    position: relative;
    .profile {
      position: relative;
      .profile-img-wrap {
        ${ProfileImgWrapStyle};
        width: 42px;
        height: 42px;
      }
    }

    .today-best-pick {
      position: absolute;
      bottom: -74px;
      left: 50%;
      transform: translateX(-60%);
      width: auto;
      height: 45px;
      img {
        width: auto;
        height: 100%;
      }
    }
    .profile-img-wrap {
      &.blocked {
         opacity: .3;
      }
    }
  }
  .pick-contents {
    flex: 1;
    width: 100%;
    text-align: left;
    .nickname {
      font-size: ${props => props.theme.font.large};
      .company-pick-name {
        font-size: ${props => props.theme.font.large};
      }
      .date {
        float: right;
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.disableTxt2};
      }
      .extra-btn {
        z-index: 0;
      }
      &.blocked {
        color: ${props => props.theme.color.btn};
        height: 21px;
        line-height: 21px;
        .company-pick-name { // 삭제된 분석글의 닉네임 스타일
          color: ${props => props.theme.color.btn};
        }
      }
    }
    .block-message {
      color: ${props => props.theme.color.disableBg};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.regular};
      height: 21px;
      line-height: 21px;
    }
    .title {
      width: calc(100% - 8px);
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.darkTxt};
      margin-top: 5px;
    }
    .select-box {
      ${SelectBoxStyle};
      margin: 9px 0 12px;
      padding: 10px 0;
      background: ${props => props.theme.color.subColor2};
    }
    .ico-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      height: 60px;
      svg {
        width: 36px;
        height: 36px;
        margin-right: 8px;
        path {
          fill: ${props => props.theme.color.disableBg};
        }
      }
      .num, .like-num {
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.btn};
      }
      &.active {
        svg .fill {
          fill: ${props => props.theme.color.underover};
        }
      }
    }
    .contents {
      .link {
        display: block;
        color: ${props => props.theme.color.blue};
      }
    }
    .rsme-embed { //sns링크보기 스타일 변경(나도승부사 분석글)
      &:first-of-type {
        margin-top: 6px;
      }
      &.rsme-instagram-embed, &.rsme-tiktok-embed {
        max-width: calc(100vw - 88px);
        overflow: hidden;
      }
    }
    &.pc {
      .rsme-embed {
        width: 100% !important;
        iframe, .fb-post {
          width: 100% !important;
          min-width: 328px;
        }
      }
    }
  }

  .line {
    position: absolute;
    bottom: 0;
    left: 14px;
    width: calc(100% - 32px);
    height: 1px;
    background: ${props => props.theme.color.subColor2};
  }
  &.popup-item {
    padding: 0 18px;
    background: none;
    .pick-contents {
      .select-box {
        margin: 6px 0 0;
        padding: 14px 0;
        color: ${props => props.theme.color.disableTxt2};
        font-size: ${props => props.theme.font.medium};
        background: ${props => props.theme.color.modalBg};
        .outcome {
          // 예측내역팝업은 다른 select-box와 달리 폰트가 한단계 작기 때문에 적용
          margin-bottom: -4px;
          .selection {
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
          }
          .outcome-rate {
            color: ${props => props.theme.color.modalOrange};
          }
        }
      }
    }
  }
`

export const UserPickContentsStyle = (theme: Theme) => css`
  color: ${theme.color.darkTxt};
  &.comment {
    color: #99A7B7;
    font-size: ${theme.font.large};
    font-weight: ${theme.fontW.medium};
    margin: 6px 12px 4px 0;
  }
  // 더보기 버튼이 있는 경우 좋아요 버튼과 간격을 벌리기 위함
  &.show-more {
    margin-bottom: 6px;
    padding-bottom: 3px;
  }
  .contents {
    &, * {
      ${CommonTxtBoxStyle};
      line-height: 2.1rem;
      font-size: ${theme.font.large};
      font-weight: ${theme.fontW.regular};
      color: ${theme.color.darkTxt};
    }
    // 나도승부사 분석글 첨부영역
    &--upload {
      ${UploadImgPreviewCommonStyle};
      max-height: 180px;
    }
  }
  .more-txt {
    display: inline-block;
    margin-top: 9px;
    color: ${theme.color.btn};
  }
  &:not(.open) {
    display: flex;
    align-items: flex-start;
    flex-flow: column;
    .contents {
      &.short {
        p {
          ${CommonLimitStyle};
          line-height: 2.1rem;
          max-height: 10rem;
        }
      }
    }
  }
  &.open {
    ${CommonTxtBoxStyle};
    .content {
      &--upload {
        display: block;
      }
    }
  }
`
export const PickTextAreaWrap = styled.div`
  margin: 0 18px;
  padding: 21px 14px 10px;
  background: ${props => props.theme.color.mainColor};
  border-radius: 9px;
  .select-box {
    ${SelectBoxStyle};
    width: auto;
    margin: 0 13px 12px;
    padding: 10px 0;
    background: ${props => props.theme.color.subColor2};
  }
  .active {
    .upload-preview {
      .delete-preview-btn {
        .bg {
          background: ${props => props.theme.color.subColor2};
        }
      }
    }
    .textarea-footer .btn-wrap .send-btn {
      color: ${props => props.theme.color.btn};
      background: ${props => props.theme.color.mainBg};
      &.active {
        color: ${props => props.theme.color.underover};
      }
    }
    .line {
      opacity: 1;
      background: ${props => props.theme.color.subColor2};
    }
    .comment-emoticon {
      background: ${props => props.theme.color.subColor2};
    }
  }
`
export const HomeBannerStyle = (theme: Theme) => css`
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  .banner-btn {
    width: 100%;
    min-height: 77px;
    border-radius: 4px;
    overflow: hidden;
  }
  .swiper {
    padding: 0 14px;
  }
  .swiper-pagination.swiper-pagination-fraction {
    opacity: 1;
    bottom: 7px;
    right: 23px;
    padding: 5px 8px 4px;
    background: rgba(121, 136, 151, .8);
    border-radius: 5px;
  }
  .fraction-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &, .swiper-pagination-current, .swiper-pagination-total {
      color: ${theme.color.modalTxt};
      font-weight: ${theme.fontW.medium};
      vertical-align: middle;
    }
    .swiper-pagination-current {
      margin-right: 1px;
    }
    .swiper-pagination-total {
      margin-left: 1px;
    }
    .arrow-ico {
      position: relative;
      transform: rotate(-45deg);
      width: 6px;
      height: 6px;
      margin-left: 6px;
      &::before, &::after {
        content:'';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        background: ${theme.color.mainColor};
      }
      &::before {
        width: 100%;
        height: 1px;
      }
      &::after {
        width: 1px;
        height: 100%;
      }
    }
  }
  .more-btn {
    z-index: 1;
    position: absolute;
    bottom: 0;
    right: 18px;
    .txt-wrap, .btn-ico {
      visibility: hidden;
    }
  }
  &:not(.right-navigation) {
    .swiper-pagination.swiper-pagination-fraction {
      width: auto;
      height: auto;
    }
  }
  // PC버전
  &.right-navigation {
    position: relative;
    .swiper {
      padding: 0 18px;
    }
    .swiper-slide {
      margin-bottom: 50px;
    }
    .swiper-pagination {
      background: rgba(44, 51, 64, .6);
      border-radius: 30px;
    }
    .swiper-button-prev, .swiper-button-next {
      bottom: 10px;
    }
    .fraction-wrap {
      background: none;
      &, .swiper-pagination-current, .swiper-pagination-total {
        color: ${theme.color.themeTxt};
      }
      .arrow-ico {
        display: none;
      }
    }
    .more-btn {
      position: absolute;
      bottom: 0;
      right: 8px;
      .txt-wrap, .btn-ico {
        visibility: initial;
      }
      .btn-ico {
        transform: translateY(1px);
        margin-left: 4px;
      }
    }
  }
`
// const giftboxAni = keyframes`
//   // 기본상태
//   0% {
//     bottom: 9px;
//     transform: translateX(-50%) scale(1, 1);
//   }
//   // X증가, Y감소
//   20% {
//     bottom: 5px;
//     transform: translateX(-50%) scale(1.05, 0.8);
//   }
//   // X감소, Y원복, 높이 ↑
//   40%{
//     bottom: 15px;
//     transform: translateX(-50%) scale(0.95, 1);
//   }
//   // X증가, Y감소, 높이 원복
//   60%{
//     bottom: 9px;
//     transform: translateX(-50%) scale(1.05, 0.95);
//   }
//   // X원복, Y증가, 높이 기본
//   80%{
//     bottom: 11px;
//     transform: translateX(-50%) scale(1, 1.1);
//   }
//   // X원복, Y원복, 높이 기본
//   100%{
//     bottom: 9px;
//     transform: translateX(-50%) scale(1, 1);
//   }
// `
const giftboxAni = keyframes`
  0%{
    transform: translateX(-50%) scale(1, 1);
    animation-timing-function: ease-out;
  }
  5% {
    transform: translateX(-50%) scale(1.15, 0.6);
    bottom: 8px;
    animation-timing-function: cubic-bezier(.37,.01,.94,.59);
  }
  10%, 11% {
    transform: translateX(-50%) scale(0.95, 1);
    bottom: 14px;
    animation-timing-function: cubic-bezier(.65,-0.01,1,.42);
  }
  17%{
    transform: translateX(-50%) scale(1, 1);
    bottom: 9px;
    animation-timing-function: linear;
  }
  20%{
    transform: translateX(-50%) scale(1.15, 0.6);
    animation-timing-function: linear;
  }
  25%{
    transform: translateX(-50%) scale(1, 1.1);
    animation-timing-function: linear;
  }
  30%{
    transform: translateX(-50%) scale(1, 1);
    animation-timing-function: linear;
  }
  100%{
    transform: translateX(-50%) scale(1, 1);
    animation-timing-function: ease-out;
  }
`
const giftBoxDecoAni = keyframes`
  0%{
    transform: scale(1, 1);
    animation-timing-function: ease-out;
  }
  5% {
    transform: scale(1.15, 0.6);
    bottom: 7px;
    animation-timing-function: cubic-bezier(.37,.01,.94,.59);
  }
  10%, 11% {
    transform: scale(0.95, 1);
    bottom: 13px;
    animation-timing-function: cubic-bezier(.65,-0.01,1,.42);
  }
  17%{
    transform: scale(1, 1);
    bottom: 8px;
    animation-timing-function: linear;
  }
  20%{
    transform: scale(1.15, 0.6);
    animation-timing-function: linear;
  }
  25%{
    transform: scale(1, 1.1);
    animation-timing-function: linear;
  }
  30%{
    transform: scale(1, 1);
    animation-timing-function: linear;
  }
  100%{
    transform: scale(1, 1);
    animation-timing-function: ease-out;
  }
`
export const FreeChargeBtnWrap = styled.div`
  z-index: 1;
  position: fixed;
  bottom: 150px;
  right: 18px;
  width: auto;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  &.pc{
    position: absolute;
    bottom: 22px;
    right: 38px;
    transform: scale(1.3);
  }
`
export const FreeChargeBtn = styled.button`
  position: relative;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: none;
  background: none;
  transform-origin: center center;
  .free-charge-btn {
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    top: -60px;
    left: 0;
    .gift-box-bubble{
      position: absolute;
      top: -34px;
      left: 58%;
      transform: translateX(-50%);
      width: 72px;
      height: auto;
    }
    .free-charge-ico-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background: linear-gradient(150deg, #FFDD00, #FFAF10);
    }
    .gift-box-icon {
      position: absolute;
      bottom: 9px;
      left: 50%;
      transform: translateX(-50%) scale(1, 1);
      transform-origin: center bottom 9px;
      width: 27px;
      height: auto;
      animation: ${giftboxAni} 3.4s 1s infinite;
      vector-effect: non-scaling-stroke;
      .line {
        fill: #330909;
      }
      .box-ribbon {
        fill: #FFCC00;
      }
      .box-bg {
        fill: #DF3B3B;
      }
    }
    &.is-season {
      .free-charge-ico-bg {
        background: linear-gradient(150deg, #F2BFC4, #E78FA3);
      }
      .gift-box-icon {
        .line {
          fill: #330909;
        }
        .box-ribbon {
          fill: #FFA6CC;
        }
        .box-bg {
          fill: #CA3763;
        }
        &-deco {
          z-index: 1;
          position: absolute;
          right: 6.5px;
          bottom: 8px;
          width: 13.5px;
          height: auto;
          transform-origin: center bottom 8px;
          animation: ${giftBoxDecoAni} 3.4s 1s infinite;
        }
      }
    }
  }
`
export const UserPickPopoverWrap = styled.div`
  width: 110px;
  height: auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  background: ${props => props.theme.color.themeTxt};
  padding: 10px;
  .popover-btn {
    width: 100%;
    height: 30px;
    border-radius: 7px;
    background: ${props => props.theme.color.modalBg};
    overflow: hidden;
    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
    &.delete {
      color: ${props => props.theme.color.modalred};
    }
  }
`
export const NoticeMoreBtnStyle = (theme: Theme) =>css`
  width: 33px;
  min-width: 33px;
  color: ${theme.color.disableBg};
  margin-left: 7px;
  white-space: nowrap;
  border-radius: 0 !important;
  line-height: 160%;
`

const characterInfoHeight = '20%'

export const PremiumPickItem = styled.div`
  width: auto;
  height: auto;
  //max-height: 336px;
  border-radius: 25px;
  background: ${props => props.theme.color.subColor2};
  margin: 0 auto 30px;
  max-width: 480px;
  .character-info-wrap {
    width: 100%;
    height: ${characterInfoHeight};
    min-height: 254px;
    position: relative;
    .character-bg-wrap {
      width: inherit;
      height: inherit;
      border-radius: 25px 25px 0 0;
      overflow: hidden;
      .character-bg-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        min-height: 254px;
      }
    }
    .character-img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: auto;
      min-height: 190px;
      height: 75%;
      &.prokey {
        left: -20px;
      }
    }
    .total-count {
      position: absolute;
      right: 20px;
      bottom: 12px;
      width: 80px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      &-list {
        width: 100%;
        height: 30px;
        border-radius: 26px;
        margin-top: 14px;
        background: #40506080;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 6px;
        svg {
          width: 24px;
          height: auto;
        }
        .num {
          font-size: ${props => props.theme.font.medium};
          color: ${props => props.theme.color.white};    
        }
      }
    }
  }
  .analyst-info-wrap {
    width: 100%;
    height: calc(100% - ${characterInfoHeight});
    padding: 12px 50px 16px 26px;
    .nick-name{
      font-size: 22px;
      margin-bottom: 3px;
      line-height: 33px;
    }
    .notice{
      display: flex;
      align-items: start;
      width: 100%;
      svg {
        width: 17px;
        min-width: 17px;
        height: auto;
        margin-right: 6px;
        margin-top: 1px;
        path {
          fill: ${props => props.theme.color.disableTxt2};
        }
      }
      .txt {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 22px;
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.disableTxt2};
      }
    }
  }
`